<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="font-size:22pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:center; text-indent:10pt; widows:0">
            <span style="font-family:黑体; font-size:22pt">个人征信客户授权书</span>
          </p>
          <p style="line-height:22pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:14pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">吉林亿联银行股份有限公司投诉咨询热线：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt">吉林亿联银行股份有限公司（以下简称：被授权人）:</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">一、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意</span>
            <span style="font-family:宋体; font-size:11pt">并</span>
            <span style="font-family:宋体; font-size:11pt">授权：被授权人按照</span>
            <span style="font-family:宋体; font-size:11pt">《征信业管理条例》等国家相关规定采集并</span>
            <span style="font-family:宋体; font-size:11pt">向中国人民银行金融信用信息基础数据库</span>
            <span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt">报送本人个人信息及信用信息（包括但不限于信贷信息及对信息主体信用状况构成负面影响的</span>
            <span style="font-family:宋体; font-size:11pt">不良</span>
            <span style="font-family:宋体; font-size:11pt">信息）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">二、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人同意</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">并</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">授权：被授权人可以</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">根据国家有关规定，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">在</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">办理涉及本人的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">信贷业务申请阶段及业务存续期间，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">向中国人民银行金融信用信息基础数据库</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询、打印、保存本人的信用信息，并用于下述用途：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人授信及贷款申请；</span>
            <span style="width:18pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">□</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人作为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">其他个人、法人、其他组织机构办理信贷业务的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">担保人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或相关还款责任人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括事前审核和事后跟踪管理环节；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">对已</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">发生的业务</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行贷后风险管理；</span>
            <span style="width:1pt; text-indent:0pt; display:inline-block"></span>
            <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">√</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">处理本人异议申请</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">□受理法人、其他组织</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">机构</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授信及</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">贷款申请</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或其作为担保人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">或相关还款责任人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，需要</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询其法定代表人、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">负责人等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">关联人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">信用状况</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括事前审核和事后跟踪管理；</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人知晓并同意被授权人有权向中国人民银行金融信用信息基础数据库核实本人资料、信息和记录，包括但不限于公积金、收入、社保、信用信息以及其他与本人有关的资料、信息和记录。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">三、</span>
            <span style="font-family:宋体; font-size:11pt">本人声明：本授权书是本人向贵行做出的单方承诺，且效力具有独立性，不因《借款额度合同》</span>
            <span style="font-family:宋体; font-size:11pt">等其他协议</span>
            <span style="font-family:宋体; font-size:11pt">条款</span>
            <span style="font-family:宋体; font-size:11pt">的</span>
            <span style="font-family:宋体; font-size:11pt">无效而失效。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">四、</span>
            <span style="font-family:宋体; font-size:11pt">本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务</span>
            <span style="font-family:宋体; font-size:11pt">终结</span>
            <span style="font-family:宋体; font-size:11pt">之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">五</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">六</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人知晓并同意若本人出现不良还款行为，被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">可按照《征信业管理条例》要求，通过本人在业务办理过程中留存的联系信息，以短信、邮件、APPPUSH、语音等方式进行不良还款行为上报告知，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若因本人留存信息错误、发生变更、服务运营商网络不稳定或故障等客观因素，导致告知信息未触达或未及时触达本人的，将视为被授权人已履行告知义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">七</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已被明确告知不良还款信息一旦记录在中国人民银行金融信用信息基础数据库中，在日后的经济活动中对本人可能产生的不良影响。包括但不限于：将上述信息应用于对本人的信用评估或出具信用报告后，可能导致本人在申请某项业务时（如网络信贷），提供该等业务的机构因参考上述信用评估或信用报告而最终拒绝或终止向本人提供该等业务；以及虽采取了严格的符合国家认证标准的安全保护措施对所采集的上述信息实施了安全保护，但仍可能存在的因不可抗力或高科技本身所不可克服的漏洞或意外的恶意黑客攻击导致部分信息泄露的风险。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">八</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人信贷业务未获批准，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止。同时，本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">同意被授权人自行删除本人个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">征信</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">资料</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，无须退回本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">九</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt">如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书内容与相关业务的合同条款不一致的，无论相关合同在本授权书之前或之后签署，均应以本授权书的内容为准</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">但相关合同条款明确约定是针对本授权书内容所做修订的除外。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十一、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人知悉，被授权人所获取的本人征信信息保存期限为【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】年。若因本人逾期还款等情形，被授权人于上述期限后仍有使用本人信息之必要的，本人同意被授权人将本人的征信信息保存至上述情形消灭之日</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">起</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">年</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">二</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本人已仔细阅读上述所有条款，并已特别注意字体加黑的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：</span>
          </p>
          <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：</span>
          </p>
          <p style="font-size:11pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：</span>
          </p>
        </div>
    </div>
  </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
